import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/bbd5a6a7-2b79-411d-a7c9-b2c2c2dc78b3";
export const REGISTER_URL = "https://a.ntrk2.com/edb57727-36dc-44d6-a0a4-b373177a947f";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://ez333.kzw2a.com/download?openExternalBrowser=1&id=icakjsrgppxwxam";

export * from "./codes";
export * from "./context";
